import React, { createContext, useState, useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';

export const SessionContext = createContext();

const SESSION_TIMEOUT = 2 * 60 * 60 * 1000; // 2 hours in milliseconds

export const SessionProvider = ({ children }) => {
  const [userId] = useState(() => {
    const storedUserId = localStorage.getItem('userId');
    if (storedUserId) {
      return storedUserId;
    } else {
      const newUserId = uuidv4();
      localStorage.setItem('userId', newUserId);
      return newUserId;
    }
  });

  const [sessionId, setSessionId] = useState(() => {
    const storedSessionId = localStorage.getItem('sessionId');
    const sessionCreationTime = localStorage.getItem('sessionCreationTime');
    const currentTime = Date.now();

    if (storedSessionId && sessionCreationTime && (currentTime - sessionCreationTime) < SESSION_TIMEOUT) {
      return storedSessionId;
    } else {
      const newSessionId = uuidv4();
      localStorage.setItem('sessionId', newSessionId);
      localStorage.setItem('sessionCreationTime', currentTime);
      return newSessionId;
    }
  });

  const [clientIP, setClientIP] = useState(null);

  useEffect(() => {
    const handleActivity = () => {
      const currentTime = Date.now();
      localStorage.setItem('sessionCreationTime', currentTime);
    };

    window.addEventListener('mousemove', handleActivity);
    window.addEventListener('keydown', handleActivity);

    return () => {
      window.removeEventListener('mousemove', handleActivity);
      window.removeEventListener('keydown', handleActivity);
    };
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      const sessionCreationTime = localStorage.getItem('sessionCreationTime');
      const currentTime = Date.now();

      if ((currentTime - sessionCreationTime) >= SESSION_TIMEOUT) {
        const newSessionId = uuidv4();
        localStorage.setItem('sessionId', newSessionId);
        localStorage.setItem('sessionCreationTime', currentTime);
        setSessionId(newSessionId);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const fetchClientIP = async () => {
      try {
        const response = await fetch('https://api.ipify.org?format=json');
        const data = await response.json();
        setClientIP(data.ip);
      } catch (error) {
        console.error('Failed to fetch client IP:', error);
      }
    };

    fetchClientIP();
  }, []);

  return (
    <SessionContext.Provider value={{ userId, sessionId, clientIP }}>
      {children}
    </SessionContext.Provider>
  );
};